import { ButtonLink, Flex, Heading, Table, Text, SrOnly } from '@applyboard/crystal-ui';
import { DocumentAlertHifiIcon, DownloadOutlineIcon, DocumentOutlineIcon } from '@applyboard/ui-icons';
import { useErrorHandler } from '~/hooks/useErrorHandler';
import { useSearchResult } from '../context/SearchResultContext';
import { ApplicationExport } from '../data';

export function ApplicationExportTable() {
  const { apiError } = useErrorHandler();
  const { applicationExports, isFetchingApplicationExports, isApplicationExportsError } = useSearchResult();

  if (isApplicationExportsError) {
    apiError();
    return null;
  }

  return (
    <Flex direction="column">
      <div role="alert" aria-live="assertive">
        {isFetchingApplicationExports && <SrOnly>Loading application exports table</SrOnly>}
      </div>
      <Table
        data={applicationExports}
        loading={isFetchingApplicationExports}
        overflow="scroll"
        columns={[
          {
            accessorKey: 'scheduleName',
            header: 'Schedule Name',
            cell: (exportItem: ApplicationExport) => {
              return (
                <Flex align="center" gap={2}>
                  <DocumentOutlineIcon />
                  <Table.TextCell>{exportItem.scheduleName}</Table.TextCell>
                </Flex>
              );
            },
          },
          {
            accessorKey: 'dateExported',
            header: 'Date Exported',
            cell: (exportItem: ApplicationExport) => <Table.TextCell>{exportItem.dateExported}</Table.TextCell>,
          },
          {
            accessorKey: 'totalRecords',
            header: 'Total Records',
            cell: (exportItem: ApplicationExport) => <Table.TextCell>{exportItem.totalRecords}</Table.TextCell>,
          },
          {
            accessorKey: 'fileSize',
            header: 'File Size',
            cell: (exportItem: ApplicationExport) => <Table.TextCell>{exportItem.fileSize}</Table.TextCell>,
          },
          {
            accessorKey: 'actions',
            header: 'Actions',
            cell: (exportItem: ApplicationExport) => (
              <ButtonLink
                aria-label={`Download ${exportItem.fileName}`}
                emphasis="outlined"
                href={exportItem.fileUrl || '#'}
                intent="secondary"
                trailIcon={DownloadOutlineIcon}
                size="sm"
                width="hug"
                disabled={!exportItem.fileUrl}
              >
                Download
              </ButtonLink>
            ),
          },
        ]}
      >
        <Table.NoData>
          <Flex align="center" justify="center" direction="column" gap={4} py={32}>
            <DocumentAlertHifiIcon />
            <Heading level={3}>No exports found!</Heading>
            <Text contrast="mid">No application exports found at the moment.</Text>
          </Flex>
        </Table.NoData>
      </Table>
    </Flex>
  );
}
